import { render } from "./Slots.vue?vue&type=template&id=39f37f2c&scoped=true&ts=true"
import script from "./Slots.vue?vue&type=script&lang=ts"
export * from "./Slots.vue?vue&type=script&lang=ts"

import "./Slots.vue?vue&type=style&index=0&id=39f37f2c&scoped=true&lang=css"

import exportComponent from "/Users/asaskevich/Work/sequoia-cabinet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f37f2c"]])

export default __exports__